import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createTransferValidationSchema = Yup.object().shape({
  bankName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankNumber: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  bankOwner: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  amount: Yup.number().required(SystemMessage.INPUT_REQUIRED),
});
